export const CAREER_MODAL_NAME = 'career';
